var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"logo-header"},[_c('img',{staticClass:"logo-image",attrs:{"src":_vm.logoPath,"alt":_vm.altText}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }